import { render } from "./CounterBlock.vue?vue&type=template&id=5a8c3b70&scoped=true"
import script from "./CounterBlock.vue?vue&type=script&lang=js"
export * from "./CounterBlock.vue?vue&type=script&lang=js"

import "./CounterBlock.vue?vue&type=style&index=0&id=5a8c3b70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8c3b70"]])

export default __exports__